
import { useNavigate } from 'react-router-dom';

export default function AlertBanner() {
  const navigate = useNavigate();

  return (
    <div className="relative bg-gradient-to-r from-red-600 via-red-500 to-red-600 text-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-3 flex-1">
            <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
              <i className="ri-file-text-line text-xl"></i>
            </div>
            <p className="text-lg font-bold">
              Read our Open Letter to Governor Newsom: The 'Third Way' for AI Safety.
            </p>
          </div>
          <button
            onClick={() => navigate('/open-letter')}
            className="bg-white text-red-600 px-6 py-2.5 rounded-lg font-semibold whitespace-nowrap hover:bg-gray-50 transition-all duration-300 hover:shadow-lg hover:scale-105 cursor-pointer"
          >
            Read Letter
          </button>
        </div>
      </div>
    </div>
  );
}
